// ============================================
// INFRASTRUCTURE - Prospecto Premium Storage
// ============================================
// Recuerda en el dispositivo el último día (horario Chile) en que se consultó si el almacén es prospecto de
// Premium, para no volver a llamar al backend más de una vez al día aunque se reabra la app.

const STORAGE_KEY = 'ad_prospecto_premium_chequeo';

interface Chequeo {
  almacenId: number;
  fecha: string; // yyyy-MM-dd en America/Santiago
}

export const prospectoPremiumStorage = {
  yaConsultadoHoy(almacenId: number, hoy: string): boolean {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const chequeo = JSON.parse(raw) as Chequeo;
      return chequeo.almacenId === almacenId && chequeo.fecha === hoy;
    } catch {
      return false;
    }
  },

  marcarConsultado(almacenId: number, hoy: string): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ almacenId, fecha: hoy } satisfies Chequeo));
    } catch (error) {
      console.error('No se pudo guardar el chequeo de prospecto Premium:', error);
    }
  },
};
